const axios = require('@/utils/axios')
const { baseURL } = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	classrooms: [],
	classroom: null,
	classroom_students : []
}

const getters = {
	fetchClassrooms: (state) => state.classrooms,
	fetchClassroom: (state) => state.classroom,
	fetchClassroomStudents: (state) => state.classroom_students
}

const actions = {
	loadClassrooms({ commit }, { token, filter = {} }) {
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`classroom?${query_str}`, {
			headers: {
				'x-auth-token': token
			}
		}).then((response) => {
			commit('SET_CLASSROOMS', response.data.data)
		})
	},
	loadClassroom({ commit }, { token, id }) {
		return $http.get(`classroom/${id}`, {
			headers: {
				'x-auth-token': token
			}
		}).then((response) => {
			commit('SET_CLASSROOM', response.data.data)
		})
	},
	loadClassroomStudents({ commit }, { token, id, analytics=false }) {
		const query_str = analytics ? `analytics=${analytics}` : ""
		return $http.get(`classroom/${id}/students?${query_str}`, {
			headers: {
				'x-auth-token': token
			}
		}).then((response) => {
			commit('SET_CLASSROOM_STUDENTS', response.data.data)
		})
	},
	createClassroom({ commit }, { token, classroom }) {
		return $http.post(`classroom`, classroom, {
			headers: {
				'x-auth-token': token
			}
		}).then((response) => {
			commit('CREATE_CLASSROOM', response.data.data)
		})
	},
	assignClassroom({ commit }, { token, assign, id }) {
		return $http.put(`classroom/${id}/assign`, assign, {
			headers: {
				'x-auth-token': token
			}
		}).then((response) => {
			commit('ASSIGN_USER', response.data.data)
		})
	}
	// updateTeacher({commit}, {id, teacher, token}){
	// 	// let category_formdata = new FormData()
	// 	// for(let key in category){
	// 	// 	if(key == 'categoryfiles'){
	// 	// 		for(let i in category[key]){
	// 	// 			category_formdata.append(`${key}`, category[key][i])
	// 	// 		}
	// 	// 	}else if(key == 'editfiles'){
	// 	// 		category_formdata.append(key, JSON.stringify(category[key]))
	// 	// 	}else{
	// 	// 		category_formdata.append(key, category[key])
	// 	// 	}	
	// 	// }

	// 	for(let key in teacher){
	// 		if(teacher[key] == null){
	// 			delete teacher[key]
	// 		}
	// 	}

	// 	return $http.put(`user/${id}`, teacher, {
	// 		headers : {
	// 			// 'Content-Type' : 'undefined',
	// 			'x-auth-token' : token
	// 		}
	// 	}).then((response) => {
	// 		commit('UPDATE_TEACHER', response.data)
	// 	})
	// },

	// deleteTeacher({commit}, {id, token}){
	// 	return $http.delete(`user/${id}`, {
	// 		headers : {
	// 			'x-auth-token' : token
	// 		} 
	// 	}).then(() => {
	// 		commit('REMOVE_TEACHER', id)	
	// 	})
	// },
}

const mutations = {
	SET_CLASSROOMS: (state, classrooms) => {
		state.classrooms = classrooms
	},
	SET_CLASSROOM: (state, classroom) => {
		state.classroom = classroom;
	},
	SET_CLASSROOM_STUDENTS : (state, students) => {
		state.classroom_students = students
	},
	CREATE_CLASSROOM: (state, classroom) => {
		state.classrooms.push(classroom)
	},
	ASSIGN_USER: (state, classroom) => {
		state.classroom = classroom
	},
	// UPDATE_CATEGORY : (state, category) => {
	// 	state.current_category = category
	// 	let cat_index = state.categories.findIndex(category_obj => category_obj._id == category._id)
	// 	Vue.set(state.categories, cat_index, Object.assign({}, category)) // For making it reactive
	// },
	// REMOVE_CATEGORY : (state, category_id) => {
	// 	state.categories = state.categories.filter(category => category._id != category_id)
	// 	if(state.current_category && (state.current_category._id == category_id)){
	// 		state.current_category = null
	// 	}
	// },
}

export default {
	state, getters, actions, mutations
}